import React, { useCallback } from 'react';
import style from './XButton.scss';
import { inIframe } from './helpers';
import { getLocationParam } from 'js/utils/url.util';
import classNames from '../../Details/DetailedPage/common/classNames';

export const XButton = (props) => {
    const { buttonWidth, buttonHeight, trackXButtonClick, isMysteryParcel } = props;
    const hideCloseButton = () => getLocationParam('hideEDCloseButton') === '1';

    const onXButtonClick = useCallback(() => {
        if (trackXButtonClick) {
            trackXButtonClick();
        }
        window.parent?.postMessage('{close-cp-iframe}', '*');
    }, [trackXButtonClick]);
    const getSize = () => {
        if (buttonWidth && buttonHeight) {
            return { width: buttonWidth, height: buttonHeight };
        }
        return {};
    };

    return inIframe() && !hideCloseButton() && <div style={getSize()} className={style.closeButton}
                                                    onClick={() => onXButtonClick()}>
        <div className={ classNames(style.firstPart, { [style.mysteryParcelColor]: isMysteryParcel })}/>
        <div className={classNames(style.secondPart, { [style.mysteryParcelColor]: isMysteryParcel })}/>
    </div>;
};
